import { useQuery } from '@tanstack/react-query';
import { getActionPlanning } from '../../api/workEnvironmentQueries';

export const ActionPlanningQueryKey = 'WORK_ENVIRONMENT_ACTION_PLANNING';

export const useActionPlanningQuery = (surveyId: number, language: string) =>
  useQuery({
    queryKey: [ActionPlanningQueryKey, surveyId, language],
    queryFn: () => getActionPlanning(surveyId, language),
  });
